import { useState } from 'react'
import { X, Download, Smartphone } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { usePWAInstall } from '@/hooks/use-pwa-install'

export function PWAInstallBanner() {
  const { isInstallable, installApp } = usePWAInstall()
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('pwa-banner-dismissed') === 'true'
  })

  const handleInstall = async () => {
    await installApp()
    setIsDismissed(true)
    localStorage.setItem('pwa-banner-dismissed', 'true')
  }

  const handleDismiss = () => {
    setIsDismissed(true)
    localStorage.setItem('pwa-banner-dismissed', 'true')
  }

  if (!isInstallable || isDismissed) {
    return null
  }

  return (
    <Card className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:max-w-sm mobile-fade-in shadow-lg border-primary/20">
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary flex-shrink-0">
            <Smartphone className="h-5 w-5" />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-sm mb-1">
              Install Waitlist Manager
            </h3>
            <p className="text-xs text-muted-foreground mb-3 leading-relaxed">
              Add to your home screen for quick access and offline support
            </p>
            
            <div className="flex gap-2">
              <Button
                size="sm"
                onClick={handleInstall}
                className="flex-1 h-10 text-xs"
              >
                <Download className="mr-1 h-3 w-3" />
                Install
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={handleDismiss}
                className="h-10 w-10 flex-shrink-0"
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}